<template>
  <v-row dense>
    <v-col cols="12" :md="showEnglish ? 6 : 12">
      <component
          :is="textarea ? 'v-textarea' : 'v-text-field'"
          :value="value.fa_value"
          @input="update('fa_value', $event)"
          :label="label + ' (فارسی)'"
          :hint="hint"
          :dir="ltr ? 'ltr' : null"
          :rows="3"
          auto-grow
          outlined
          dense
          color="#00ADB5"
      ></component>
    </v-col>
    <v-col v-if="showEnglish" cols="12" md="6">
      <component
          :is="textarea ? 'v-textarea' : 'v-text-field'"
          :value="value.en_value"
          @input="update('en_value', $event)"
          :label="label + ' (English)'"
          :hint="hint"
          :rows="3"
          auto-grow
          outlined
          dense
          dir="ltr"
          color="#00ADB5"
      ></component>
    </v-col>
  </v-row>
</template>

<script>
import {VTextarea, VTextField} from "vuetify/lib";

export default {
  name: "TranslatedField",

  components: {VTextarea, VTextField},

  props: {
    // {fa_value, en_value}
    value: {
      type: Object,
      default: () => ({fa_value: '', en_value: ''}),
    },
    label: {
      type: String,
      required: true,
    },
    hint: {
      type: String,
      default: '',
    },
    textarea: {
      type: Boolean,
      default: false,
    },
    // URLs and other non-prose values read left to right in both languages.
    ltr: {
      type: Boolean,
      default: false,
    },
  },

  computed: {
    showEnglish() {
      return this.$store.state.showEnglishFields
    },
  },

  methods: {
    update(key, text) {
      this.$emit('input', {...this.value, [key]: text})
    },
  },
}
</script>
